export const seniorityDateFormatter = {
  dateToMonthsAndYears: (date?: Date | null) => {
    if (!date) return undefined;

    const now = new Date();
    const past = new Date(date);

    let years = now.getFullYear() - past.getFullYear();
    let months = now.getMonth() - past.getMonth();

    if (months < 0) {
      years--;
      months += 12;
    }

    if (months >= 12) {
      const extraYears = Math.floor(months / 12);
      years += extraYears;
      months = months % 12;
    }

    return {
      seniorityYears: years,
      seniorityMonths: months,
    };
  },
  monthsAndYearsToDate: (months: number | undefined, years: number | undefined) => {
    if (months === undefined || years === undefined) return undefined;
    if (months < 0 || years < 0) return undefined;

    if (months >= 12) {
      const extraYears = Math.floor(months / 12);
      years += extraYears;
      months = months % 12;
    }

    if (months > 11) return undefined;
    const currentDate = new Date();
    currentDate.setFullYear(currentDate.getFullYear() - years);
    currentDate.setMonth(currentDate.getMonth() - months);
    currentDate.setDate(1);

    return currentDate;
  },
};
